import React, { Component, useEffect } from 'react';
import IdleTimer from 'react-idle-timer';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';

import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import Dashboard from '../../views/Dashboard/';

import ShortcutsBar from '../../components/ShortcutsBar/ShortcutsBar';

import Usuarios from '../../views/Usuarios/Usuarios/';
import Permisos from '../../views/Usuarios/Permisos/';
import Grupos from '../../views/Usuarios/Grupos/';
import Empresas from '../../views/Empresas/Empresas/';

import ConsultadorArticulos from '../../views/ConsultadorArticulos';


import Articulos from '../../views/Gestion/Articulos/Articulos/';
import Propiedades from '../../views/Gestion/Articulos/Propiedades/';
import Destacados from '../../views/Gestion/Articulos/Destacados/';
import Categorias from '../../views/Gestion/Articulos/Categorias/';
import Colores from '../../views/Gestion/Articulos/Colores/';
import GruposArt from '../../views/Gestion/Articulos/Grupos/';
import Lineas from '../../views/Gestion/Articulos/Lineas/';
import Marcas from '../../views/Gestion/Articulos/Marcas/';
import Materiales from '../../views/Gestion/Articulos/Materiales/';
import Rubros from '../../views/Gestion/Articulos/Rubros/';
import Talles from '../../views/Gestion/Articulos/Talles/';
import UnidadesMedida from '../../views/Gestion/Articulos/UnidadesMedida/';
import Modelos from '../../views/Gestion/Articulos/Modelos/';
import Proveedores from '../../views/Gestion/Articulos/Proveedores/';

import Precios from '../../views/Gestion/Precios/Precios';
import Listas from '../../views/Gestion/Precios/Listas';
import Asignar from '../../views/Gestion/Precios/Asignar';

import Stock from '../../views/Gestion/Stock/Stock';
import Depositos from '../../views/Gestion/Stock/Depositos';
import Sucursales from '../../views/Gestion/Stock/Sucursales';

import Provincias from '../../views/Gestion/Generales/Provincias';
import Localidades from '../../views/Gestion/Generales/Localidades';
import TiposDoc from '../../views/Gestion/Generales/TiposDoc';
import Transportes from '../../views/Gestion/Generales/Transportes';
import Impuestos from '../../views/Gestion/Generales/Impuestos';
import Monedas from '../../views/Gestion/Generales/Monedas';
import SituacionIVA from '../../views/Gestion/Generales/SituacionIVA';

import CondicionesDePago from '../../views/Gestion/Ventas/CondicionesDePago';
import Vendedores from '../../views/Gestion/Ventas/Vendedores';
import Clientes from '../../views/Gestion/Ventas/Clientes';
import Pedidos from '../../views/Gestion/Ventas/Pedidos';
import Ofertas from '../../views/Gestion/Ventas/Ofertas';

import Configuracion from '../../views/Gestion/Sitio/Configuracion';
import Novedades from '../../views/Gestion/Sitio/Novedades';
import Bitacoras from '../../views/Gestion/Sitio/Bitacoras';
import Plantillas from '../../views/Gestion/Sitio/Mails/Plantillas/Plantillas';
import Casillas from '../../views/Gestion/Sitio/Mails/Casillas/Casillas';

import Movimientos from '../../views/Gestion/CuentasCorrientes';

import Tarjetas from '../../views/Gestion/Ventas/Tarjetas';

import auth from '../../auth/auth';
import Menues from '../../components/Menues';
import api, { menu } from '../../api/api';
import apifunctions from '../../api/functions';

import Ayuda from '../../views/Ayuda';

const defaultMenu = Menues.root[0].items;

const Otros = ({ otros }) => {

  const style = {
    height: "100vh",
    width: "100%",
    border: "none"
  }

  const load = (src) => {
    return src.replace('{token}', localStorage.getItem('token_gestion'))
      .replace('{public_token}', localStorage.getItem('public_token_gestion'))
  }

  return (
    otros.map(o =>
      <Route
        path={o.url}
        name={o.nombre}
        component={() => <iframe style={style} src={load(o.src)} />}
      />
    )
  );
}


class Full extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idle: false,
      menu: defaultMenu,
      otros: []
    }
    this.idleTimer = null;
  }

  componentDidMount() {

    const onSuccesCallBack = (data) => {
      if (data.data && data.data.length > 0) {
        this.loadOtrosMenu(data.data);
      }
    }

    apifunctions.get(
      api.menu.otros, null, null, {},
      onSuccesCallBack,
      () => { },
      () => { }
    );

  }

  loadOtrosMenu(otros) {

    let itemOtro = defaultMenu.filter(item => item.name == 'Otros')[0];
    itemOtro.items = otros.map(item => ({
      name: item.nombre,
      url: item.url,
      permission: item.permiso
    }));

    let newMenu = defaultMenu.filter(item => item.name != 'Otros')
    newMenu.push(itemOtro);

    this.setState({
      menu: newMenu,
      otros: otros
    });
  }

  onIdle = e => {
    auth.logout();
    this.setState(() => ({
      idle: true
    }));
  }

  render() {

    if (this.state.idle) {
      return <Redirect to="/locked" />
    }

    document.body.classList.remove('sidebar-mobile-show');

    return (
      <div className="app">
        <IdleTimer
          ref={ref => { this.idlerTimer = ref }}
          element={document}
          onIdle={this.onIdle}
          timeout={1000 * 60 * 30}
        > {/*30 Minutos*/}
          <Header />
          <div className="app-body">
            <Sidebar menu={this.state.menu} {...this.props} isDnDDisabled={true} />
            <main className="main">
              <Container fluid>
                <Switch>

                  <Route path="/dashboard" name="Dashboard" component={Dashboard} />

                  <Route path="/usuarios/usuarios/" name="Usuarios" component={Usuarios} />
                  <Route path="/usuarios/permisos/" name="Permisos" component={Permisos} />
                  <Route path="/usuarios/grupos/" name="Grupos" component={Grupos} />

                  <Route path="/gestion/empresas/" name="Empresas" component={Empresas} />

                  <Route path="/consultador/articulos/" name="ConsultadorWeb" component={ConsultadorArticulos} />

                  <Route path="/articulos/articulos/" name="Articulos" component={Articulos} />
                  <Route path="/articulos/caracteristicas/" name="Propiedades" component={Propiedades} />
                  <Route path="/articulos/destacados/" name="Destacados" component={Destacados} />
                  <Route path="/articulos/categorias/" name="Categorias" component={Categorias} />
                  <Route path="/articulos/colores/" name="Colores" component={Colores} />
                  <Route path="/articulos/grupos/" name="GruposArt" component={GruposArt} />
                  <Route path="/articulos/lineas/" name="Lineas" component={Lineas} />
                  <Route path="/articulos/marcas/" name="Marcas" component={Marcas} />
                  <Route path="/articulos/materiales/" name="Materiales" component={Materiales} />
                  <Route path="/articulos/rubros/" name="Rubros" component={Rubros} />
                  <Route path="/articulos/talles/" name="Talles" component={Talles} />
                  <Route path="/articulos/unidadesmedida/" name="UnidadesMedida" component={UnidadesMedida} />
                  <Route path="/articulos/modelos/" name="Modelos" component={Modelos} />
                  <Route path="/articulos/proveedores/" name="Proveedores" component={Proveedores} />

                  <Route path="/stock/stock/" name="Stock" component={Stock} />
                  <Route path="/stock/depositos/" name="Depositos" component={Depositos} />
                  <Route path="/stock/sucursales/" name="Sucursales" component={Sucursales} />

                  <Route path="/generales/provincias/" name="Provincias" component={Provincias} />
                  <Route path="/generales/localidades/" name="Localidades" component={Localidades} />
                  <Route path="/generales/tiposdocumentos/" name="TiposDoc" component={TiposDoc} />
                  <Route path="/generales/transportes/" name="Transportes" component={Transportes} />
                  <Route path="/generales/impuestos/" name="Impuestos" component={Impuestos} />
                  <Route path="/generales/monedas/" name="Monedas" component={Monedas} />
                  <Route path="/generales/situacioniva/" name="SituacionIVA" component={SituacionIVA} />

                  <Route path="/sitio/novedades/" name="Novedades" component={Novedades} />
                  <Route path="/sitio/bitacora/" name="Bitacoras" component={Bitacoras} />
                  <Route path="/sitio/configuracion/" name="Configuracion" component={Configuracion} />
                  <Route path="/sitio/mails/plantillas/" name="Plantillas" component={Plantillas} />
                  <Route path="/sitio/mails/casillas/" name="Casillas" component={Casillas} />

                  <Route path="/precios/precios/" name="Precios" component={Precios} />
                  <Route path="/precios/listas/" name="Listas" component={Listas} />
                  <Route path="/precios/asignar/" name="Asignar" component={Asignar} />

                  <Route path="/ventas/condicionesdepago/" name="CondicionesDePago" component={CondicionesDePago} />
                  <Route path="/ventas/tarjetas/" name="Tarjetas" component={Tarjetas} />
                  <Route path="/ventas/vendedores/" name="Vendedores" component={Vendedores} />
                  <Route path="/ventas/clientes/" name="Clientes" component={Clientes} />
                  <Route path="/ventas/ofertas/" name="Ofertas" component={Ofertas} />
                  <Route path="/ventas/pedidos/" name="Pedidos" component={Pedidos} />
                  <Route path="/cuentascorrientes/movimientos/" name="Movimientos" component={Movimientos} />

                  <Route path="/ayuda/" name="Ayuda" component={Ayuda} />

                  { this.state.otros && this.state.otros.length > 0 && <Otros otros={this.state.otros} /> }

                  {
                    auth.hasPermission('consultadorarticulos_view') == true ?
                    <Redirect to="/consultador/articulos/" />
                    :
                    <Redirect to="/dashboard" />
                  }
                </Switch>
              </Container>
            </main>
          </div>
        </IdleTimer>
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js